import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export var searchTags = createAction("".concat(reduxKey, ".SEARCH_TAGS"), function (query) { return ({ query: query }); });
export var searchSuccess = createAction("".concat(reduxKey, ".SEARCH_SUCCESS"), function (tags) { return ({ tags: tags }); });
export var searchFailure = createAction("".concat(reduxKey, ".SEARCH_FAILURE"), function () { return ({}); });
//# sourceMappingURL=actions.js.map